import HcLayout from '@/layouts/hc'

export default [
  {
    name: 'hc',
    path: '/',
    redirect: '/service/detail',
    component: HcLayout,
    children: [
      {
        name: 'detail',
        path: '/service/detail',
        component: () => import('_hc/goodsDetail'),
        meta: {
          title: '详情'
        }
      }
    ]
  }
]
